import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import OverflowTooltip from '@shared/overflow-tooltip';
import FilterCheckbox from '@shared/filter-checkbox';
import '../filter.scss';

const FilterGroupItem = ({
  enabled,
  currentValues,
  filterEnabled,
  filterName,
  getIcon,
  item,
  onToggleCheckbox
}) => {
  const icon = getIcon ? getIcon(item) : null;

  const handleChange = useCallback(() => {
    onToggleCheckbox(item.id);
  }, [item.id, onToggleCheckbox]);

  return (
    <div styleName="list-item list-item-half" key={item.id}>
      <div styleName="checkbox">
        <FilterCheckbox
          checked={includes(currentValues, item.id)}
          disabled={!filterEnabled || !enabled}
          onChange={handleChange}
          name={item.name}
          // item.name (e.g. "No Designation") repeats across unrelated filter groups, which
          // native 'name'-attribute grouping would read as one shared checkbox group.
          inputName={`${filterName}-${item.id}`}
        />
      </div>
      {icon && <div styleName="icon">{icon}</div>}
      <OverflowTooltip title={item.name} styleName="label">
        {item.name}
      </OverflowTooltip>
    </div>
  );
};

FilterGroupItem.propTypes = {
  currentValues: PropTypes.array,
  enabled: PropTypes.bool,
  filterEnabled: PropTypes.bool,
  filterName: PropTypes.string,
  getIcon: PropTypes.func,
  item: PropTypes.object,
  onToggleCheckbox: PropTypes.func
};

export default FilterGroupItem;
